<template>
    <div
        class="page-buy"
        v-show="show"
        @click.stop="show = false"
    >
        <transition name="buy">
            <div
                class="content"
                v-if="show"
                @click.stop="empty"
            >
                <div
                    class="modal-content"
                    v-if="form"
                >
                    <h5>{{'交易信息填写'|language}}</h5>
                    <div
                        class="my-form"
                        v-if="company"
                    >
                        <div class="company-name">
                            <img
                                :src="company.logo"
                                alt=""
                            >
                            <div class="input-field">
                                <input
                                    type="text"
                                    class="validate"
                                    readonly
                                    :value="company.projectName"
                                ><!-- -->
                            </div>
                        </div>

                        <div class="gz">
                            <div class="switch second">
                                <span>{{'交易币种'|language}}：</span>
                                <label>
                                    <span
                                        class="rmb"
                                        :class="!check ? 'check1' : ''"
                                    >{{'美元'|language}}</span>
                                    <input
                                        type="checkbox"
                                        v-model="check"
                                    >
                                    <span class="lever"></span>
                                    <span
                                        class="rmb"
                                        :class="check ? 'check2' : ''"
                                    >{{'人民币'|language}}</span>
                                </label>
                            </div>
                            <div class="first">
                                {{'最新估值'|language}}：
                                <span :class="check ? 'check2' : 'check1'">{{gzNum | w2e}}</span>
                            </div>
                        </div>
                        <div class="tradeWay switch ">
                            <span>{{'交易方式'|language}}：</span>
                            <label>
                                <span
                                    class="rmb"
                                    :class="!calcType ? 'btn-active check1' : ''"
                                >{{'按估值'|language}}</span>
                                <input
                                    type="checkbox"
                                    v-model="calcType"
                                >
                                <span class="lever"></span>
                                <span
                                    class="rmb"
                                    :class="calcType ? 'btn-active check2' : ''"
                                >{{'按股'|language}}</span>

                            </label>
                        </div>
                        <div class="trade">
                            <span>{{'交易类型'|language}}：</span>
                            <a
                                class="waves-effect waves-light btn"
                                @click.stop="form.tradeType = 1"
                                :class="form.tradeType == 1 ? 'red white-text' : 'white red-text'"
                            >
                                <i
                                    class="material-icons right"
                                    v-if="form.tradeType == 1"
                                >checked</i>
                                <span>{{'买'|language}}</span>
                            </a>
                            <a
                                class="waves-effect waves-light btn"
                                @click.stop="form.tradeType = 2"
                                :class="form.tradeType == 2 ? 'red white-text' : 'white red-text'"
                            >
                                <i
                                    class="material-icons right"
                                    v-if="form.tradeType == 2"
                                >checked</i>
                                {{'卖'|language}}
                            </a>
                        </div>
                        <div></div>
                        <div class="input-field real-gz">
                            <input
                                id="gz"
                                type="text"
                                class="validate"
                                v-model="form.valuePrice"
                            >
                            <label
                                for="gz"
                                v-if='!calcType'
                            >
                                {{'对应公司估值'|language}}
                                <template v-if='!en'>
                                    ('亿')
                                </template>
                                <template v-else>
                                    (billion)
                                </template>
                            </label>
                            <label
                                for="gz"
                                v-if='calcType'
                            >
                                {{'对应公司每股单价'|language}}
                                <template v-if='!en'>
                                    <span>（{{!check?'美元':'元'}}）</span>
                                </template>
                                <template v-else>
                                    <span>（{{!check?'$':'CNY'}}）</span>
                                </template>
                            </label>
                        </div>
                        <div class="gz-hint">
                            <i class="material-icons">filter_drama</i>
                            <template v-if='form.tradeType == 1'>
                                <span>{{'根据近期交易情况，建议估值范围'|language}}：{{ gzNum|w2e}}-{{gzNum*1.1|w2e}}</span>
                            </template>
                            <template v-if="form.tradeType==2">
                                <span>{{'根据近期交易情况，建议估值范围'|language}}：{{ gzNum*0.9|w2e}}-{{gzNum|w2e}}</span>
                            </template>
                        </div>

                        <div class="input-field real-gz">
                            <input
                                id="jy"
                                type="text"
                                class="validate"
                                v-model="form.tradePrice"
                            >
                            <label
                                for="jy"
                                v-if='!calcType'
                            >
                                {{'交易额度'|language}}（{{'万'|language}}）
                            </label>
                            <label
                                for="gz"
                                v-if='calcType'
                            >
                                {{'购买股数'|language}}
                            </label>
                        </div>

                        <a
                            class="waves-effect waves-light btn red lighten-1 submit"
                            @click.stop="submit"
                        >
                            {{'提交'|language}}
                            <i
                                class="material-icons"
                                v-if="loading"
                            >cached</i>
                        </a>

                    </div>
                </div>
            </div>
        </transition>

    </div>
</template>

<script>
import { toast } from '../util/alert.js';
import { timeoutPromise } from '../util/jq.js';
import { HttpClient } from '../util/http.js';
export default {
    props: ['company'],

    data() {
        return {
            ins: null,
            check: true,
            show: false,
            loading: false,
            form: null,
            calcType: false,
        };
    },
    computed: {
        gzNum() {
            return this.check
                ? parseInt(this.company.gz.rmb)
                : parseInt(this.company.gz.dollar);
        },
    },
    methods: {
        empty() {},
        toggleBuy(type) {
            this.show = true;
            this.check = this.company.valueType == 1 ? true : false;
            this.form = {
                tradeType: type,
            };
        },
        async submit() {
            if (this.loading) return;
            if (!this.form.valuePrice || !this.form.tradePrice) {
                toast('信息未填写完全');

                return;
            }
            let data = {
                // 交易币种 美元人民币
                valueType: this.check ? 1 : 2,
                // 交易类型 买卖
                tradeType: this.form.tradeType == 1 ? 0 : 1,
                company: this.company._id,
            };
            // 按股交易
            if (this.calcType) {
                data.calcType = 1;
                data.moneyPerStock = this.calcType
                    ? this.form.valuePrice
                    : null;
                data.buyStockNum = this.calcType ? this.form.tradePrice : null;
            } else {
                // 按估值交易
                data.calcType = 0;
                data.valuePrice = this.calcType ? null : this.form.valuePrice;
                data.tradePrice = this.calcType ? null : this.form.tradePrice;
            }

            function timePromise(time) {
                return new Promise(resolve => {
                    setTimeout(resolve, time);
                });
            }
            try {
                this.loading = true;
                let [res] = await Promise.all([
                    HttpClient.post('/trade/create', data),
                    timePromise(1500),
                ]);
                if (res) {
                    this.show = false;
                    toast('提交信息成功');
                    history.back();
                }
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="less">
.page-buy {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    .buy-enter-active,
    .buy-leave-active {
        transition: all ease 0.5s;
    }
    .buy-enter,
    .buy-leave-to {
        transform: scale(0);
        opacity: 0;
    }
    .content {
        width: 600px;
        background: white;
        transform-origin: 50%, 50%;
        padding-top: 20px;
    }
    .my-form {
        width: 500px;
        margin: 30px auto 0;
        padding-bottom: 40px;
        .submit {
            width: 50%;
            margin: 30px auto 0;
            display: flex;
            align-items: center;
            justify-content: center;
            @keyframes loading {
                100% {
                    transform: rotate(360deg);
                }
            }
            i {
                animation: loading 0.6s linear infinite;
            }
        }
        .gz-hint {
            width: 100%;
            display: flex;
            align-items: center;
            i {
                margin: 10px;
            }
        }
        .trade {
            display: flex;
            align-items: center;
            margin-top: 40px;
            > a {
                margin-right: 20px;
                transition: all ease 0.5s;
                // width: 100px;
                i {
                    width: 25px;
                }
            }
        }
        .company-name {
            display: flex;
            align-items: center;
            > img {
                height: 30px;
                width: 30px;
                margin-bottom: 12px;
                margin-right: 15px;
            }
            > div {
                flex: auto;
            }
        }
        .gz {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 30px;
            .first {
                span {
                    font-weight: bold;
                    font-size: 18px;
                }
            }
            .second {
                .rmb {
                    font-weight: bold;
                    font-size: 16px;
                    line-height: 24px;
                }
                input {
                    margin: 5px;
                }
            }
            .check1 {
                color: #ffab00;
            }
            .check2 {
                color: #bc242b;
            }
        }
        .tradeWay {
            // background-color: red;
            position: relative;
            top: 20px;
            text-align: left;
            label .rmb {
                font-size: 16px;
            }
            .check1 {
                font-size: 16px;
                color: #ffab00;
            }
            .check2 {
                font-size: 16px;
                color: #bc242b;
            }
        }

        .real-gz {
            margin-top: 40px;
            padding-bottom: 0;
            margin-bottom: 0;
        }
    }
}
</style>

